import React, { useState, useEffect } from 'react';
import { Layout, theme } from 'antd';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import UserProfile from '../../screens/citizen/UserProfile';

const { Content } = Layout;

const MainLayout = () => {
  const { token } = theme.useToken();
  const [userProfileVisible, setUserProfileVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(window.innerWidth < 992);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleUserProfileClick = () => {
    setUserProfileVisible(true);
  };

  const handleUserProfileClose = () => {
    setUserProfileVisible(false);
  };

  return (
    <Layout style={{ minHeight: '100vh', overflow: 'hidden', position: 'relative' }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} isMobile={isMobile} />
      {isMobile && !collapsed && (
        <div
          onClick={() => setCollapsed(true)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.35)',
            zIndex: 1100
          }}
        />
      )}
      <Layout style={{ 
        overflow: 'hidden',
        marginLeft: isMobile ? 0 : (collapsed ? '80px' : '280px'), // Adjust for collapsed state
        transition: 'margin-left 0.2s ease'
      }}>
        <Header collapsed={collapsed} setCollapsed={setCollapsed} isMobile={isMobile} onUserProfileClick={handleUserProfileClick} />
        <Content
          style={{
            margin: isMobile ? '5px 10px 12px' : '5px 10px 12px',
            padding: isMobile ? 12 : 24,
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            minHeight: 280,
            overflowY: 'auto',
            height: isMobile ? 'calc(100vh - 88px)' : 'calc(100vh - 112px)',
            maxHeight: isMobile ? 'calc(100vh - 88px)' : 'calc(100vh - 112px)'
          }}
        >
          <Outlet />
        </Content>
      </Layout>
      
      {/* User Profile Modal */}
      <UserProfile 
        visible={userProfileVisible}
        onClose={handleUserProfileClose}
      />
    </Layout>
  );
};

export default MainLayout;
